import React from "react";
import { useState } from "react";
import InfoIcon from "@mui/icons-material/Info";
import HelpIcon from "@mui/icons-material/Help";
import { Collapse, IconButton, SxProps, Theme } from "@mui/material";
import BNAlert from "../../BNAlert/BNAlert";

interface Props {
  tooltip: string;
  timeout?: number;
  setHtml?: boolean;
  helpIcon?: boolean;
  iconButtonSx?: SxProps<Theme>;
  trackValue?: string;
  trackEventName?: string;
}

const BNLabelTooltip: React.FC<Props> = (props) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const { trackValue, trackEventName } = props;

  const toggleTooltip = (shouldShow: boolean, trackValue: string | undefined, trackEventName: string | undefined) => {
    if (shouldShow && trackValue && trackEventName) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "GAEvent",
        GA4EventName: trackEventName,
        GA4InputFieldName1: "input_field",
        GA4InputFieldValue1: trackValue,
      });
    }

    setShowTooltip(shouldShow);
  };

  return (
    <>
      <IconButton
        size="small"
        sx={props.iconButtonSx}
        onClick={() => toggleTooltip(!showTooltip, trackValue, trackEventName)}
      >
        {props.helpIcon ? <HelpIcon fontSize="small" /> : <InfoIcon fontSize="small" />}
      </IconButton>
      <Collapse in={showTooltip} timeout={props.timeout || 200}>
        <BNAlert customIcon={<></>} severity="info" sx={{ borderRadius: "1rem" }}>
          {props.setHtml ? <div dangerouslySetInnerHTML={{ __html: props.tooltip }} /> : props.tooltip}
        </BNAlert>
      </Collapse>
    </>
  );
};

export default BNLabelTooltip;
